/*
  Behaviour for the floating social launcher in 'snippets/elshrouk-social.liquid'.

  Three jobs, all small: open and close the group, keep it clear of whatever is
  fixed along the bottom edge of that page, and tuck it away when the footer
  arrives so it never covers the links down there.

  The clearance is measured rather than guessed at a breakpoint. On a wide
  screen the product page's buy bar is a narrow centred pill that never reaches
  this corner, and on a phone it spans the whole width; comparing the two boxes
  answers that for every width without a media query, and the same test picks up
  the comparison tray for free.
*/
(function () {
  var root = document.querySelector('.es-social');
  if (!root) return;

  var toggle = root.querySelector('.es-social__toggle');
  var list = root.querySelector('.es-social__list');
  if (!toggle || !list) return;

  function isOpen() {
    return root.dataset.open === 'true';
  }

  function setOpen(open) {
    root.dataset.open = open ? 'true' : 'false';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  toggle.addEventListener('click', function () {
    setOpen(!isOpen());
  });

  /* Anywhere else on the page closes it. The toggle's own click is excluded by
     the containment test, so this does not undo the line above. */
  document.addEventListener('click', function (event) {
    if (!isOpen()) return;
    if (root.contains(event.target)) return;
    setOpen(false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!isOpen()) return;
    setOpen(false);
    toggle.focus();
  });

  /* Tabbing out of the group closes it too, so it is never left standing open
     behind the rest of the page. */
  root.addEventListener('focusout', function (event) {
    if (!isOpen()) return;
    if (root.contains(event.relatedTarget)) return;
    setOpen(false);
  });

  /* ---------- Clearance along the bottom edge ---------- */

  var GAP = 12;
  var BASE = 18; /* matches inset-block-end in elshrouk-social.css */
  var applied = 0;
  var queued = false;

  function reposition() {
    queued = false;

    var box = root.getBoundingClientRect();
    var bars = [
      document.querySelector('.sticky-add-to-cart__bar[data-stuck="true"]'),
      document.querySelector('.es-cmp-tray:not([hidden])')
    ];
    var needed = 0;

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      if (!bar) continue;

      var rect = bar.getBoundingClientRect();
      if (rect.height < 1) continue;

      /* Only a bar that shares this column can actually cover the launcher. */
      if (rect.right <= box.left || rect.left >= box.right) continue;

      needed = Math.max(needed, window.innerHeight - rect.top + GAP - BASE);
    }

    needed = Math.max(0, Math.round(needed));
    if (needed === applied) return;

    applied = needed;
    root.style.setProperty('--es-social-lift', needed + 'px');
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(reposition);
  }

  /* Both bars announce themselves with an attribute, so there is nothing to
     poll: the buy bar flips data-stuck, the tray drops hidden. */
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-stuck', 'hidden']
    });
  }

  /* ---------- Getting out of the footer's way ---------- */

  var footer = document.querySelector('.page-wrapper > footer');
  var footerWatch = null;

  function watchFooter() {
    if (!footer || !('IntersectionObserver' in window)) return;
    if (footerWatch) footerWatch.disconnect();

    /* The observed area is only the strip of viewport the launcher sits in, so
       it tucks away when the footer is genuinely underneath it rather than as
       soon as the footer appears at the bottom of a tall screen. */
    var strip = Math.max(0, window.innerHeight - 110);

    footerWatch = new IntersectionObserver(
      function (entries) {
        /* Tucking away is for a reader who has arrived at the foot of the page.
           On a page with nothing to scroll nobody has arrived anywhere, and
           hiding the launcher there would just make it missing, so that case is
           left alone. */
        var scrollable = document.documentElement.scrollHeight - window.innerHeight > 80;
        var covered = scrollable && !!(entries[0] && entries[0].isIntersecting);

        root.dataset.tucked = covered ? 'true' : 'false';
        if (covered) setOpen(false);
      },
      { rootMargin: '-' + strip + 'px 0px 0px 0px' }
    );

    footerWatch.observe(footer);
  }

  window.addEventListener('resize', function () {
    schedule();
    watchFooter();
  });

  watchFooter();
  schedule();
})();